import { ICustomLeagueDictionaryApi } from '@/types';

export class CustomLeagueDictionaryItem {
    ageCategoryId: number;
    categoryId: number;
    countryId: number | null;
    gender: number;
    id: number;
    limitsCategoryId: number;
    name: string;

    constructor(data: ICustomLeagueDictionaryApi) {
        this.id = data.id;
        this.name = data.name;
        this.ageCategoryId = data.age_category_id;
        this.categoryId = data.category_id;
        this.countryId = data.country_id;
        this.limitsCategoryId = data.limits_category_id;
        this.gender = data.gender;
    }
}
